import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	searchIcon: {
		'& .MuiButtonBase-root': {
			transform: 'rotate(0deg)',
		},
	},
}));
